/**
 * Phone number formatting helpers.
 *
 *   • +19781234567 → "(978) 123-4567"
 *   • +14135550100 → "(413) 555-0100"
 *   • unrecognized formats returned unchanged
 */
export const formatPhoneDisplay = (e164) => {
  if (!e164) return "";
  const s = String(e164).trim();
  const m = s.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  if (m) return `(${m[1]}) ${m[2]}-${m[3]}`;
  return s;
};

/** Best-effort E.164-ify a user-typed US number. */
export const toE164 = (input) => {
  if (!input) return "";
  const digits = String(input).replace(/\D/g, "");
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  if (String(input).trim().startsWith("+")) return String(input).trim();
  return input;
};

export const formatDuration = (seconds) => {
  const s = Math.max(0, Number(seconds) || 0);
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m >= 60) {
    const h = Math.floor(m / 60);
    return `${h}h ${m % 60}m`;
  }
  return `${m}m ${String(r).padStart(2, "0")}s`;
};
